// extracted by mini-css-extract-plugin
export var discard = "_4z-3";
export var muiTooltipTooltip = "_4z-5";
export var notificationBar = "_4z-2";
export var saveButtonHoverSlotWrapper = "_4z-4";
export var show = "_4z-1";
export var spacer = "_4z-0";